var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.elementBindings.is,_vm._g(_vm._b({tag:"component",staticClass:"button-base",class:{ 'button-base--button': _vm.isButton }},'component',_vm.elementBindings,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }